
import abi from './claimAbi.json'

// const contractAddress = '0x3761ea1f6A41cdDa4BCFA5c42f5362D200DBfE9E';  // bsctestnet contract address
const contractAddress = '0xF6C9f79d0041E2b63625496BF2FEac83A08892f0';  // Add your deployed contract address

export { abi, contractAddress };

